import { principles } from "@/mocks/site";

export default function PrinciplesSection() {
  return (
    <section aria-labelledby="home-principles" className="mx-auto max-w-content px-4 py-16 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <h2 id="home-principles" className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            我们怎么处理每一条传闻
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            从收到线索到发布公告，流程固定、口径统一。下面是四条贯穿始终的操作原则。
          </p>
          <div className="mt-6 h-1 w-16 rounded-full bg-primary-500" />
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-8">
          {principles.map((item, index) => (
            <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-50 text-xl text-primary-700">
                  <i className={item.icon} />
                </span>
                <span className="font-heading text-sm font-bold text-foreground-400">
                  0{index + 1}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}